import { CLEAR_PAGE } from '../base/types';
import { FETCH_TASKS, CREATE_TASK, UPDATE_TASK, UPLOAD_TASK_FILE, DELETE_TASK, DELETE_TASK_FILE } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const tasksReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_TASKS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_TASKS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_TASKS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_TASK}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, payload],
      };
    case `${DELETE_TASK}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };
    case `${UPDATE_TASK}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${UPLOAD_TASK_FILE}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.taskId)) {
            return { ...i, files: [...(i.files || []), payload] };
          }
          return i;
        }),
      };
    case `${DELETE_TASK_FILE}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.taskId)) {
            return { ...i, files: (i.files || []).filter(f => Number(f?.id) !== Number(payload?.fileId)) };
          }
          return i;
        }),
      };

    case CLEAR_PAGE:
      return payload === 'tasks' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default tasksReducer;
